/**
 * Contest iframe module creation and resize handling
 * @module lib/contest/iframe
 */

const { createIframeResizer } = require('../utils/iframeResizer');
const { buildContestIframeUrl, resolveContestArticleId } = require('./urls');

const ensureContestIframeResizer = createIframeResizer({
  messageType: 'MILLA_CONTEST_RESIZE',
  minHeight: 300,
  maxHeight: 1600,
  scrollMessageType: 'MILLA_CONTEST_SCROLL_TO'
});

/**
 * Create a contest iframe module (DOM element)
 * @param {object} options
 * @param {string} options.contestId
 * @param {string} [options.articleId]
 * @param {string} [options.location]
 * @returns {HTMLElement|null}
 */
function createContestIframeModule(options = {}) {
  if (typeof document === 'undefined') return null;
  ensureContestIframeResizer();

  const contestId = typeof options.contestId === 'string' ? options.contestId.trim() : '';
  if (!contestId) return null;

  const articleId = resolveContestArticleId(options.articleId);
  const location = typeof options.location === 'string' && options.location.trim()
    ? options.location.trim()
    : 'article_end';
  const iframeUrl = buildContestIframeUrl(contestId, { articleId, location });
  if (!iframeUrl) return null;

  const iframe = document.createElement('iframe');
  iframe.src = iframeUrl;
  iframe.loading = 'lazy';
  iframe.title = 'Contest entry';
  iframe.setAttribute('scrolling', 'no');
  iframe.style.border = '0';
  iframe.style.width = '100%';
  const isInline = typeof location === 'string' && location.startsWith('article');
  const initialHeight = isInline ? 620 : 520;
  iframe.style.height = `${initialHeight}px`;
  iframe.style.overflow = 'hidden';

  const wrapper = document.createElement('div');
  wrapper.style.width = '100%';
  wrapper.style.margin = isInline ? '16px 0' : '0 0 16px 0';
  wrapper.style.minHeight = `${initialHeight}px`;
  wrapper.style.fontFamily =
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
  wrapper.appendChild(iframe);
  return wrapper;
}

module.exports = {
  ensureContestIframeResizer,
  createContestIframeModule
};
